import React from "react";

const SITE_URL  = "https://seanthesciencekid.net/";
const MERCH_URL = "https://sean-the-science-kid.dashery.com/";
const LOGO      = "/icon-192.png";

/**
 * Sean's World — official site + merch dual-card.
 * Sits just above the Booking Agreement, anchored at #sean-world.
 */
export default function SeanWorldSection() {
  return (
    <section
      id="sean-world"
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 mt-12"
      data-testid="sean-world-section"
    >
      <div className="mb-5 text-center">
        <div className="eyebrow text-[var(--orange)]">explore sean's world</div>
        <h2 className="font-display text-3xl sm:text-4xl text-[var(--ink)]">Site, Shop & Sciencer Swag</h2>
        <p className="text-[var(--ink-soft)] mt-1 max-w-2xl mx-auto">
          Visit Sean's official home base and grab merch designed by the Science Kid himself —
          worn by Sciencers across the country. 🧡
        </p>
      </div>

      <div className="grid sm:grid-cols-2 gap-4 sm:gap-5 max-w-4xl mx-auto">
        {/* Official Site */}
        <a
          href={SITE_URL}
          target="_blank"
          rel="noreferrer noopener"
          className="card card-hover tint-orange no-underline block text-center"
          data-testid="sean-world-site"
        >
          <div className="flex flex-col items-center">
            <img
              src={LOGO}
              alt="Sean The Science Kid logo"
              className="rounded-2xl"
              style={{
                width: 88, height: 88,
                border: "2.5px solid var(--ink)",
                boxShadow: "3px 3px 0 0 var(--ink)",
                background: "#fff",
                objectFit: "contain",
              }}
            />
            <div className="eyebrow text-[var(--red)] mt-3">official site</div>
            <div className="font-display text-2xl text-[var(--ink)] leading-tight mt-0.5">
              seanthesciencekid.net
            </div>
            <p className="text-sm text-[var(--ink-soft)] mt-2 max-w-xs">
              Bookings, press, news, and everything Sean is up to in the lab.
              His home page — direct from the Science Kid HQ.
            </p>
            <div className="mt-4 pill" style={{ background: "var(--orange)", color: "#fff" }}>
              Visit site ↗
            </div>
          </div>
        </a>

        {/* Merch Store */}
        <a
          href={MERCH_URL}
          target="_blank"
          rel="noreferrer noopener"
          className="card card-hover tint-red no-underline block text-center"
          data-testid="sean-world-merch"
        >
          <div className="flex flex-col items-center">
            <div
              className="rounded-2xl overflow-hidden"
              style={{
                width: 88, height: 88,
                border: "2.5px solid var(--ink)",
                boxShadow: "3px 3px 0 0 var(--ink)",
                background: "#fff",
              }}
            >
              <img
                src="/sean-merch-new.jpg"
                alt="Sean's official merch"
                style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
              />
            </div>
            <div className="eyebrow text-[var(--navy)] mt-3">official merch</div>
            <div className="font-display text-2xl text-[var(--ink)] leading-tight mt-0.5">
              Shop the Lab
            </div>
            <p className="text-sm text-[var(--ink-soft)] mt-2 max-w-xs">
              Tees, hoodies, stickers and more — designed by Sean. Wear your
              Sciencer status. Every purchase fuels more science.
            </p>
            <div
              className="mt-4 pill"
              style={{ background: "var(--red)", color: "#fff" }}
            >
              Shop merch ↗
            </div>
          </div>
        </a>
      </div>
    </section>
  );
}
